import styled from 'styled-components';

import { BasicParagraph, SmallParagraph, style } from '@genially/design-system';

interface WrapperProps {
  $isSelected: boolean;
}

// The exported artwork already carries its own background, border and rounded corners.
export const Illustration = styled.img(({ theme: { size } }) => ({
  display: 'block',
  width: '100%',
  height: 'auto',

  // Stacked, the card reads as a row: the artwork keeps its own width on the left and
  // spans the title and description rows next to it.
  ...style.mixins.responsive.sm.downward({
    gridRow: '1 / span 2',
    width: size.units(12),
  }),
}));

export const TitleRow = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: size.units(1),
}));

export const Title = styled(BasicParagraph)(({ theme: { color } }) => ({
  color: color.content.primary.default(),
  fontWeight: 700,
}));

export const Description = styled(SmallParagraph)(({ theme: { color, size } }) => ({
  paddingLeft: size.units(3),
  color: color.content.secondary.default(),
}));

export const Wrapper = styled.label<WrapperProps>(
  ({ theme: { color, size, transition }, $isSelected }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: size.units(1),
    padding: size.units(1.5),
    borderRadius: size.units(1.5),
    cursor: 'pointer',
    border: `1px solid ${
      $isSelected ? color.border.accent.default() : color.border.primary.default()
    }`,
    boxShadow: $isSelected ? `0 0 0 1px ${color.border.accent.default()}` : 'none',
    transition: transition.standard('border-color', 'box-shadow'),

    '&:hover': {
      borderColor: color.border.accent.default(),
    },

    ...style.mixins.responsive.sm.downward({
      display: 'grid',
      gridTemplateColumns: 'auto 1fr',
      alignItems: 'center',
      columnGap: size.units(1.5),
    }),
  }),
);
